export default "__VITE_ASSET__tfe5uS8R__"